<template>
    <div>
        <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="所属代理商：">
                <el-input v-model.trim="searchForm.agentName" @keyup.enter.native="getOrderListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="所属业务员：">
                <el-select v-model="searchForm.yewuId" filterable>
                    <el-option v-for="item in yewuData" :value="item.id" :key="item.id"
                        :label="item.name + '（' + item.sysUserAccountName + '）'"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="通道名称：">
                <el-select v-model="searchForm.supplierCode" placeholder="请选择" clearable filterable>
                    <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id"
                        :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐系列：">
                <el-select v-model="searchForm.basePkgGroup" clearable filterable>
                    <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="号码：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getOrderListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="订单号：">
                <el-input v-model.trim="searchForm.orderNo" @keyup.enter.native="getOrderListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="第三方单号：">
                <el-input v-model.trim="searchForm.payNo" @keyup.enter.native="getOrderListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="充值类型：">
                <el-select v-model="searchForm.investType" clearable>
                    <el-option label="首次充值" value="0"></el-option>
                    <el-option label="续费充值" value="1"></el-option>
                    <el-option label="自动续费" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="推送状态：">
                <el-select v-model="searchForm.sendState" clearable>
                    <el-option label="待推送" value="0"></el-option>
                    <el-option label="已推送" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="生效时间：">
                <el-select v-model="searchForm.isNextMonth" clearable>
                    <el-option label="本月生效" value="0"></el-option>
                    <el-option label="次月生效" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单状态：">
                <el-select v-model="searchForm.payState" clearable>
                    <el-option v-for="item in orderState" :key="item.description" :label="item.description"
                        :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单来源：">
                <el-select v-model="searchForm.createType" clearable>
                    <el-option v-for="item in orderSource" :key="item.description" :label="item.description"
                        :value="item.code"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="下单时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <br />
            <el-form-item label="批量搜索：" class="iccid_textarea_range">
                <el-input type="textarea" :rows="2" placeholder="多个虚拟号/多个ICCID，请用逗号、空格、或者换行分隔。 ICCID和虚拟号不能同时混用,不支持导出"
                    v-model="searchForm.batchIccid">
                </el-input>
            </el-form-item>

            <el-form-item class="btnArea">
                <el-button type="primary" @click="getOrderListHandle" plain icon="el-icon-search"><i></i> 查询</el-button>
                <el-button type="primary" @click="reloadSearch" plain><i></i> 重置搜索条件</el-button>
                <el-button type="primary" @click="bacthBackUser" plain><i></i> 批量退款</el-button>
                <el-button type="primary" @click="bacthUpdateTime" plain><i></i> 批量修改时间</el-button>
                <el-button type="success" icon="el-icon-download" plain @click="exportOrderInfoHandle">导出Excel</el-button>
            </el-form-item>


            <div>
                <el-button type="primary" plain>总订单数：{{ remarkMap.totalOrderNum }}条</el-button>
                <el-button type="primary" plain>总销售额：{{ remarkMap.totalPrice }}元</el-button>
                <el-button type="warning" plain>总成本：{{ remarkMap.totalVeriPrice }}元</el-button>
                <el-button type="warning" plain>代理分润：{{ remarkMap.totalCommission }}元</el-button>
                <el-button type="success" plain>总利润：{{ remarkMap.totalMyPrice }}元</el-button>
            </div>
        </el-form>

        <el-table :data="tbpg.tableData" border fit highlight-current-row style="width: 100%;"
            :header-cell-style="{ background: '#f5f5f5' }" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" />
            <el-table-column label="订单号" width="170" align="center" show-overflow-tooltip>
                <template v-slot="scope">
                    <el-tooltip v-if="scope.row.payNo" class="item" effect="dark" :content="scope.row.payNo">
                        <p> {{ scope.row.orderNo }}</p>
                    </el-tooltip>
                    <p v-else> {{ scope.row.orderNo }}</p>
                </template>
            </el-table-column>
            <el-table-column width="160" prop="agentPathNames" align="center" label="所属代理商"
                show-overflow-tooltip></el-table-column>
            <el-table-column label="ICCID号" width="160" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="intoNo" align="center" label="虚拟号" width="120"></el-table-column>
            <el-table-column prop="packageName" align="center" label="套餐名" width="150"></el-table-column>
            <el-table-column align="center" label="支付状态" width="70">
                <template v-slot="scope">
                    <el-tooltip v-if="scope.row.payState == 1" class="item" effect="dark" :content="scope.row.payNo">
                        <p style="color:green"> {{ scope.row.payStateName }}</p>
                    </el-tooltip>
                    <el-tooltip v-else-if="scope.row.payState == 3 || scope.row.payState == 4" class="item" effect="dark"
                        :content="scope.row.payNo">
                        <p style="color:red"> {{ scope.row.payStateName }}</p>
                    </el-tooltip>
                    <el-tooltip v-else class="item" effect="dark" :content="scope.row.payNo">
                        <p style="color:teal"> {{ scope.row.payStateName }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column align="center" label="订单状态" width="70">
                <template v-slot="scope">
                    <el-tooltip v-if="scope.row.upPayStateNam == '订单正常'" class="item" effect="dark"
                        :content="scope.row.upRemark">
                        <p style="color:green"> {{ scope.row.upPayStateNam }}</p>
                    </el-tooltip>
                    <el-tooltip v-else class="item" effect="dark" :content="scope.row.upRemark">
                        <p style="color:red"> {{ scope.row.upPayStateNam }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="priceRmb" align="center" label="支付(元)" width="70"></el-table-column>
            <el-table-column prop="verifyPrice" align="center" label="成本(元)" width="70"></el-table-column>
            <el-table-column prop="commissionRmb" align="center" label="分佣(元)" width="70"></el-table-column>
            <el-table-column align="center" label="盈利(元)" width="70">
                <template v-slot="scope">
                    <el-tooltip v-if="scope.row.payState == 1" :content="scope.row.payNo">
                        <p style="color:hotpink"> {{ scope.row.winPrice }}</p>
                    </el-tooltip>
                    <el-tooltip v-else>
                        <p> 0</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="createTypeName" align="center" label="订单来源" show-overflow-tooltip></el-table-column>
            <el-table-column prop="supplierName" align="center" label="所属通道" width="120"
                show-overflow-tooltip></el-table-column>
            <el-table-column prop="investTypeName" align="center" label="充值类型" width="80"></el-table-column>
            <el-table-column prop="isNextMonthName" align="center" label="生效时间" width="70"></el-table-column>
            <el-table-column prop="createTime" align="center" label="下单时间" width="150"></el-table-column>
            <el-table-column label="操作" width="180" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showOrderDetail(scope.row)">详情</el-button>

                    <el-button type="text" size="small" @click="showBackMoneyDialog(scope.row)"
                        v-if="scope.row.payState == 1 && scope.row.createType != 0">
                        <span style="color: red;">
                            申请退款
                        </span>
                    </el-button>

                    <el-button type="text" size="small" @click="showBackMoneyDetailDialog(scope.row.orderNo, $event)"
                        v-show="scope.row.payState == 3 && scope.row.createType == 4">
                        <span style="color: red;">
                            退款详情
                        </span>
                    </el-button>

                    <el-button type="text" size="small" @click="showSecondBackList(scope.row.orderNo, $event)"
                        v-if="(scope.row.payState == 1 && scope.row.sendState == 1 && (scope.row.createType == 2 || scope.row.createType == 3))">返佣详情</el-button>

                    <el-button v-if="scope.row.payState == 0 && scope.row.payType == 20" type="text" size="small"
                        @click="resetOrderStateHandle(scope.row)">同步订单</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize"
                :total="tbpg.total" background layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
        <el-dialog :append-to-body="true" title="订单详情" :visible.sync="orderDetailVisible" width="600px"
            :close-on-click-modal="false">
            <div class="lineInDialog">
                <label>订单号：</label>
                <span>{{ orderDetailForm.orderNo }}</span>
            </div>
            <div class="lineInDialog">
                <label>代理商名称：</label>
                <span>{{ orderDetailForm.agentName }}</span>
            </div>
            <div class="lineInDialog">
                <label>ICCID号：</label>
                <span>{{ orderDetailForm.iccid }}</span>
            </div>
            <div class="lineInDialog">
                <label>套餐名称：</label>
                <span>{{ orderDetailForm.packageName }}</span>
            </div>
            <div class="lineInDialog">
                <label>下单金额：</label>
                <span>{{ orderDetailForm.priceRmb }} 元</span>
            </div>
            <div class="lineInDialog">
                <label>支付状态：</label>
                <span>{{ orderDetailForm.payStateName }}</span>
            </div>
            <div class="lineInDialog">
                <label>卡来源：</label>
                <span>{{ orderDetailForm.supplierTypeCodeName }}</span>
            </div>
            <div class="lineInDialog">
                <label>销售佣金：</label>
                <span>{{ orderDetailForm.commissionRmb }} 元</span>
            </div>
            <div class="lineInDialog">
                <label>下单时间：</label>
                <span>{{ orderDetailForm.createTime }}</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="orderDetailVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
        <el-dialog :append-to-body="true" title="退款申请" :visible.sync="backMoneyDialogVisible" width="600px"
            :close-on-click-modal="false">
            <div class="lineInDialog">
                <label>订&nbsp;单&nbsp;号：</label>
                <span>{{ rowData.orderNo }}</span>
            </div>
            <div class="lineInDialog">
                <label>ICCID号：</label>
                <span>{{ rowData.iccid }}</span>
            </div>
            <div class="lineInDialog">
                <label>下单金额：</label>
                <span>{{ rowData.priceRmb }} 元</span>
            </div>

            <div class="lineInDialog">
                <label class="label-defined">付款凭证：</label>
                <div class="many">
                    <div class="uploadOuter">
                        <input type="file" @change="showImg($event, 'existImg', 'payImg')">
                        <div v-if="!existImg">点击上传付款凭证</div>
                        <img v-else :src="payImg" alt="">
                    </div>
                </div>
            </div>
            <div class="lineInDialog">
                <label>退款原因：</label>
                <el-input type="textarea" placeholder="请输入内容" :rows="5" v-model.trim="backMoneyForm.remark"
                    clearable></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelToBackMoney">取 消</el-button>
                <el-button type="primary" @click="handleBackMoney">申 请</el-button>
            </span>
        </el-dialog>
        <el-dialog :append-to-body="true" title="秒返记录" :visible.sync="backVisible" width="1000px"
            :close-on-click-modal="false">
            <el-table :data="tbpg_back.tableData" border height="421">
                <el-table-column prop="costOrderNo" label="业务流水号" width="180"></el-table-column>
                <el-table-column prop="orderNo" label="订单号" width="180"></el-table-column>
                <el-table-column prop="agentName" label="代理商名称"></el-table-column>
                <el-table-column prop="commissionRmb" label="返现金额（元）" width="120"></el-table-column>
                <el-table-column prop="isCashbackName" label="是否已秒返" width="100"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="tbpg_back.currentPage" :page-sizes="[10, 50, 100, 500]" :page-size="tbpg_back.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="tbpg_back.total">
            </el-pagination>
            <span slot="footer" class="dialog-footer">
                <el-button @click="backVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
        <el-dialog :append-to-body="true" title="退款详情" :visible.sync="backMoneyDetailVisible" width="1000px"
            :close-on-click-modal="false">
            <el-table :data="tbpg_back.tableData" border height="421">
                <el-table-column prop="orderNo" label="订单号" width="240"></el-table-column>
                <el-table-column prop="agentName" label="代理商名称"></el-table-column>
                <el-table-column prop="backPriceRmb" label="退款金额（元）"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="tbpg_back.currentPage" :page-sizes="[10, 50, 100, 500]" :page-size="tbpg_back.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="tbpg_back.total">
            </el-pagination>
            <span slot="footer" class="dialog-footer">
                <el-button @click="backMoneyDetailVisible = false">关 闭</el-button>
            </span>
        </el-dialog>



        <el-dialog :append-to-body="true" title="修改套餐时间" :visible.sync="endTimeVisible" width="600px" @close="endTimecancel"
            :close-on-click-modal="false">
            <el-form ref="endTimeForm" :model="endTimeForm" label-width="120px">
                <p style="color: red; font-weight:bold">年包套餐不支持此操作。本次操作预计数量{{ endTimeForm.allSize }}/条</p>
                <!-- <el-form-item label="修改方式：" prop="type">
                    <el-select v-model="endTimeForm.type">
                        <el-option value="1" label="指定过期时间">指定过期时间</el-option>
                        <el-option value="2" label="指定延长天数"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item v-if="endTimeForm.type == 1" label="新开始时间：" prop="newTimeString">
                    <el-date-picker v-model="endTimeForm.newEndString" type="date" placeholder="选择日期"
                        value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item v-if="endTimeForm.type == 1" label="新过期时间：" prop="newTimeString">
                    <el-date-picker v-model="endTimeForm.newTimeString" type="date" placeholder="选择日期"
                        value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item v-else label="延长天数：" prop="dayNum">
                    <el-input v-model="endTimeForm.dayNum" placeholder="请输入天数" clearable></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input type="textarea" v-model="endTimeForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="endTimecancel">取 消</el-button>
                <el-button type="primary" @click="sureChangePkgEndTimeHandler">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog :append-to-body="true" title="批量退款" :visible.sync="backFlg" width="600px" @close="endTimecancel"
            :close-on-click-modal="false">
            <el-form ref="bacthBackData" :model="bacthBackData" label-width="120px">
                <p style="color: red; font-weight:bold">注意：此操作会直接进行退款 如部分支付订单不支持原路退回用户，请选择不打款。本次操作预计数量{{
                    bacthBackData.allSize }}/条</p>
                <div class="lineInDialog">
                    <label class="label-defined" prop="isBack">审核结果：</label>
                    <div style="display: inline-block; line-height: 32px;">
                        <el-radio-group v-model="bacthBackData.backType">
                            <el-radio :label="1">同意（打款）</el-radio>
                            <el-radio :label="0">同意（不打款）</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="lineInDialog">
                    <label class="label-defined" prop="isBack">扣除比列：</label>
                    <div style="display: inline-block; line-height: 32px;">
                        <el-radio-group v-model="bacthBackData.backUserType">
                            <el-radio :label="1">按使用流量</el-radio>
                            <el-radio :label="0">按充值金额</el-radio>
                        </el-radio-group>
                    </div>
                </div>

                <div class="lineInDialog" v-if="bacthBackData.backUserType == 0">
                    <label class="label-defined">退款比列：</label>
                    <el-input-number v-model="bacthBackData.backParent" :precision="2" :step="1" :min="0.00"
                        :max="100"></el-input-number><label class="label-defined text-align-left">&nbsp;%</label>
                </div>
                <div class="lineInDialog" v-if="bacthBackData.backUserType == 1">
                    <label class="label-defined">每G金额：</label>
                    <el-input-number v-model="bacthBackData.backParent" :precision="2" :step="1" :min="0.00"
                        :max="100"></el-input-number><label class="label-defined text-align-left">&nbsp;元/G</label>
                    <p style="color: red; font-weight:bold">注意：不满足1G按1G扣费</p>
                </div>

                <el-form-item label="退款备注：" prop="remark">
                    <el-input type="textarea" v-model="bacthBackData.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="endTimecancel">取 消</el-button>
                <el-button type="primary" @click="sureToBackUrl">确 定</el-button>
            </div>
        </el-dialog>


    </div>
</template>
<script>
import { getOrderList, getSecondBackList, exportOrderInfo, getOrderStateList, getOrderSourceList, backMoney, backMoneyDetail, resetOrderState } from '@/api/order.js'
import common from '@/utils/common.js'

export default {
    data() {
        return {
            yewuData: [],
            searchForm: {
                agentName: '',
                supplierCode: '',
                iccid: '',
                yewuId: '',
                orderNo: '',
                investType: '',
                batchIccid: '',
                time: '',
                payState: '',
                isNextMonth: null,
                createType: '',
                sendState: '',
                payNo: null,
                basePkgGroup: ''
            },
            pkgGroup: [],
            orderState: [],
            orderSource: [],
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            orderDetailVisible: false,
            orderDetailForm: {},
            branchSupplierOption: [],
            backVisible: false,    //秒返记录
            currentOrderNo_back: '',
            tbpg_back: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            backMoneyDialogVisible: false,    //退款
            rowData: {},
            backMoneyForm: {
                remark: ""
            },

            backMoneyDetailVisible: false, //退款详情
            existImg: false,
            payImg: '',
            formDate: {},

            remarkMap: {},


            bacthBackData: {
                backUserType: 1,//0按充值比列 1使用流量比列
                allOrder: '', //多个订单号以-拼成字符串 如A-B-C
                allSize: '0', //选中的数量
                backParent: '',// 退款比列
                backType: 1,// 1审核通过打款  2 审核通过不打款
            },
            backFlg: false,

            multipleSelection: [],

            endTimeVisible: false,     //修改过期时间
            endTimeForm: {
                allOrder: '',
                allSize: '0',
                type: '1',
                pkgId: '',
                oldTimeString: '',
                newTimeString: '',
                dayNum: 0,
                remark: '',
                total: '',
                use: '',
                newEndString: ''
            },


        }
    },
    methods: {
        reloadSearch() {
            this.searchForm = {};
            this.getOrderListHandle();
        },
        handleSelectionChange(data) {
            this.multipleSelection = data;
        },
        bacthBackUser() {
            this.bacthBackData.allSize = this.multipleSelection.length
            this.bacthBackData.allOrder = this.multipleSelection.map(item => {
                return item.orderNo
            }).join('-')
            if (!this.bacthBackData.allOrder) {
                this.$message.error('请勾选操作订单号！');
                return;
            }
            this.backFlg = true;
        },
        sureToBackUrl() {
            common.sysRequest('order/batch/back', this.bacthBackData, 'post').then(res => {
                if (res.data.code === '200') {
                    this.$message.success(res.data.message);
                    this.getOrderListHandle();
                    this.endTimecancel();
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        bacthUpdateTime() {
            this.endTimeForm.allSize = this.multipleSelection.length
            this.endTimeForm.allOrder = this.multipleSelection.map(item => {
                return item.orderNo
            }).join('-')
            if (!this.endTimeForm.allOrder) {
                this.$message.error('请勾选操作订单号！');
                return;
            }
            this.endTimeVisible = true;
        },
        endTimecancel() {
            this.endTimeVisible = false;
            this.backFlg = false;
            this.$refs.bacthBackData.resetFields();
            this.$refs.endTimeForm.resetFields();
        },
        sureChangePkgEndTimeHandler() {
            common.sysRequest('order/batch/update', this.endTimeForm, 'post').then(res => {
                if (res.data.code === '200') {
                    this.$message.success(res.data.message);
                    this.endTimecancel();
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },



        goToDetailPage(row) {
            this.$store.commit('menu/setFromPage', 'orderMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getOrderListHandle($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

            getOrderList(data).then(res => {
                this.remarkMap = res.data.data.remarkMap;
                common.listCallback(this, res, 'tbpg');
            })
        },
        exportOrderInfoHandle() {
            common.deleteSpaceKey(this.searchForm);

            this.$confirm('确定导出吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                exportOrderInfo(this.searchForm).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(err => console.error(err));
            }).catch(() => {

            });
        },
        showOrderDetail(row) {
            this.orderDetailVisible = true;
            this.orderDetailForm = row;
        },
        //“退款操作” 对话框
        showBackMoneyDialog(row) {
            this.backMoneyDialogVisible = true;
            this.rowData = row;
        },

        cancelToBackMoney() {
            this.backMoneyDialogVisible = false;
            this.formDate.delete('payImg');
            this.formDate.delete('orderId');
            this.formDate.delete('rqReason');
            this.rowData.id = '';
            this.backMoneyForm.remark = '';
            this.payImg = '';
            this.existImg = false;
        },

        //“退款详情” 
        showBackMoneyDetailDialog(orderNo, $event) {
            this.backMoneyDetailVisible = true;
            this.currentOrderNo_back = orderNo
            var searchForm = {
                orderNo: this.currentOrderNo_back
            }
            common.resetCurrentPage(this, $event, 'tbpg_back');
            var data = common.getRequestParams(this, 'tbpg_back', searchForm);
            getSecondBackList(data).then(res => {
                common.listCallback(this, res, 'tbpg_back');
            })
        },
        showSecondBackList(orderNo, $event) {
            this.backVisible = true;
            this.currentOrderNo_back = orderNo
            var searchForm = {
                orderNo: this.currentOrderNo_back
            }
            common.resetCurrentPage(this, $event, 'tbpg_back');
            var data = common.getRequestParams(this, 'tbpg_back', searchForm);
            getSecondBackList(data).then(res => {
                common.listCallback(this, res, 'tbpg_back');
            })
        },
        handleSizeChange(val) {
            if (this.backVisible || this.backMoneyDetailVisible) {
                this.tbpg_back.pageSize = val;
                this.showSecondBackList(this.currentOrderNo_back);
            } else {
                this.tbpg.pageSize = val;
                this.getOrderListHandle();
            }

        },
        handleCurrentChange(val) {
            if (this.backVisible) {
                this.tbpg_back.currentPage = val;
                this.showSecondBackList(this.currentOrderNo_back);
            } else {
                this.tbpg.currentPage = val
                this.getOrderListHandle();
            }
        },
        handleBackMoney() {
            if (this.backMoneyForm.remark == '') {
                this.$message.error('请先输入退款原因！');
                return;
            }
            this.formDate.append('orderId', this.rowData.id);
            this.formDate.append('rqReason', this.backMoneyForm.remark);

            this.$confirm('确定提交退款申请吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                backMoney(this.formDate).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message)
                    }

                    this.formDate.delete('payImg');
                    this.formDate.delete('orderId');
                    this.formDate.delete('rqReason');
                    this.rowData.id = '';
                    this.backMoneyForm.remark = '';
                    this.payImg = '';
                    this.existImg = false;
                    this.backMoneyDialogVisible = false;

                    this.getOrderListHandle();
                });
            }).catch(() => {

            });

        },
        handleBackMoneyDetail(row) {
            let params = {};
            params.id = row.id;
            backMoneyDetail(params).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }
            });

        },
        resetOrderStateHandle(row) {
            var data = {
                id: row.id,
                payState: 0
            }
            resetOrderState(data).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message)
                    this.getOrderListHandle();
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },

        showImg(event, showImgkey, imgUrl) {
            this.$data[showImgkey] = true;
            this.existImg = true;
            const files = event.target.files;

            let filename = files[0].name          //只有一个文件
            if (filename.lastIndexOf('.') <= 0) {
                return alert("Please add a valid image!")        //判断图片是否有效
            }
            const fileReader = new FileReader()                //内置方法new FileReader()   读取文件
            fileReader.addEventListener('load', () => {
                this.$data[imgUrl] = fileReader.result
            })
            fileReader.readAsDataURL(files[0])
            this.image = files[0];
            this.formDate.append('payImg', files[0]);
        }
    },
    created() {
        common.getAgentListOptionComs(this, 'yewuData');
        common.getPkgGroupListCom(this, 'pkgGroup');
        this.formDate = new FormData();
        let fromPage = this.$store.state.menu.fromPage;
        if (fromPage == 'userAccountFlowRecord') {
            this.searchForm.orderNo = this.toOrderMgtOrderNo;
            this.getOrderListHandle();
            this.$store.commit('menu/setFromPage', '');
            this.$store.commit('menu/setToOrderMgtOrderNo', '');
        } else {
            this.getOrderListHandle();
        }

        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
        getOrderStateList().then(res => {
            if (res.data.code == 200) {
                this.orderState = res.data.data;
            }
        })
        getOrderSourceList().then(res => {
            if (res.data.code == 200) {
                this.orderSource = res.data.data;
            }
        })
    },

    mounted() {

    },

    computed: {
        toOrderMgtOrderNo: function () {
            return this.$store.state.menu.toOrderMgtOrderNo;
        },
    },

    watch: {
        toOrderMgtOrderNo: function () {
            let fromPage = this.$store.state.menu.fromPage;

            if (fromPage == 'userAccountFlowRecord') {
                this.searchForm.orderNo = this.toOrderMgtOrderNo;
                this.getOrderListHandle();
                this.$store.commit('menu/setFromPage', '');
                this.$store.commit('menu/setToOrderMgtOrderNo', '');
            }
        }
    },

}
</script>
<style lang="less" scoped>
.label-defined {
    display: inline-block;
    height: 32px;
    line-height: 32px;
}

.text-align-left {
    text-align: left
}

.many {
    display: flex;
    justify-content: space-between;

    label {
        display: block;
        line-height: 36px;
    }

    .uploadOuter {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 180px;
        min-height: 100px;
        max-height: 250px;
        border: 1px dashed #e5e5e5;
        box-sizing: border-box;

        input[type=file] {
            position: absolute;
            top: 0;
            width: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
        }

        img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>

